import API from '../../../helpers/request/api';

const api = () => new API();

const postAttributes = `{
  id
  title
  content
  kind
  open_date
  close_date
  liked_by_user
  cached_votes_up
  moderation_state
  number_of_comments
  created_at
  followed_by_user
  bookmarked
  pinned_at
  pinned_at_aside
  medias {
    id
    url
    kind
  }
  user {
    id
    name
    photo
  }
  community_user {
    id
    permission
    is_active
    is_muted
    qty_badges
  }
  tags {
    id
    name
  }
}`;

const fetchPosts = (params) => {
  const {
    communityId,
    title,
    content,
    moderationState,
    tag = null,
    kind = '',
    postsOrderBy,
  } = params;
  const page = params.page || 1;
  let student = '';
  let search = '';

  if (params.search && params.search.startsWith('#')) {
    student = params.search.substring(1).trim();
  } else {
    search = params.search;
  }

  const query = {
    variables: {
      communityId,
      page,
      title,
      content,
      postsOrderBy,
      search,
      moderationState,
      student,
    },
    query: `query community_posts($communityId: String!, $page: Int!, $title: String, $postsOrderBy: String, $content: String, $search: String, $moderationState: [String], $student: String) {
      community_posts(
        community_id: $communityId,
        page: $page,
        tag: ${tag},
        kind: "${kind}",
        title: $title,
        order_column: $postsOrderBy,
        content: $content,
        moderation_state: $moderationState,
        search: $search,
        student: $student
      ) ${postAttributes}
    }`,
  };

  return api().get(query);
};

const countPosts = (params) => {
  const { communityId, title, content, moderationState, tag = null, kind = '' } = params;

  let student = '';
  let search = '';

  if (params.search && params.search.startsWith('#')) {
    student = params.search.substring(1).trim();
  } else {
    search = params.search;
  }

  const query = {
    variables: { communityId, title, content, search, moderationState, student },
    query: `query count_community_posts($communityId: String!, $title: String, $content: String, $search: String, $moderationState: [String], $student: String) {
      count_community_posts(
        community_id: $communityId,
        tag: ${tag},
        kind: "${kind}",
        title: $title,
        content: $content,
        moderation_state: $moderationState,
        search: $search,
        student: $student,
      ) {}
    }`,
  };

  return api().get(query);
};

const fetchAsidePosts = (params) => {
  const {
    communityId,
    title,
    content,
    search,
    moderationState,
    tag = null } = params;

  const page = params.page || 1;

  const query = {
    variables: { communityId, page, title, content, search, moderationState },
    query: `query community_aside_posts($communityId: String!, $page: Int!, $title: String, $content: String, $search: String, $moderationState: [String]) {
      community_aside_posts(
        community_id: $communityId,
        page: $page,
        tag: ${tag},
        is_pinned_aside: true,
        title: $title,
        content: $content,
        moderation_state: $moderationState,
        search: $search
      ) ${postAttributes}
    }`,
  };

  return api().get(query);
};

const countAsidePosts = (params) => {
  const {
    communityId,
    title,
    content,
    search,
    moderationState,
    tag = null } = params;

  const query = {
    variables: { communityId, title, content, search, moderationState },
    query: `query count_community_aside_posts($communityId: String!, $title: String, $content: String, $search: String, $moderationState: [String]) {
      count_community_aside_posts(
        community_id: $communityId,
        tag: ${tag},
        is_pinned_aside: true,
        title: $title,
        content: $content,
        moderation_state: $moderationState,
        search: $search
      ) {}
    }`,
  };

  return api().get(query);
};

const createPost = (postData) => {
  const openDate = postData.open_date || '';
  const closeDate = postData.close_date || '';
  const pinnedAt = postData.pinned_at || '';
  const pinnedAtAside = postData.pinned_at_aside || '';

  const {
    title,
    communityId,
    content,
    kind,
    tags,
    videos,
    images,
    mentions } = postData;

  const query = {
    variables: {
      title,
      content,
      kind,
      openDate,
      closeDate,
      pinnedAt,
      pinnedAtAside,
      tags,
      videos,
      images,
      mentions,
    },
    query: `mutation createCommunityPost(
      $title: String!,
      $content: String,
      $kind: String!,
      $openDate: String!,
      $closeDate: String!,
      $pinnedAt: String!,
      $pinnedAtAside: String!,
      $tags: [Int],
      $videos: [String],
      $images: [String],
      $mentions: [Int]
    ) {
      createCommunityPost(input: {
        community_id: ${communityId},
        title: $title,
        content: $content,
        kind: $kind,
        open_date: $openDate,
        close_date: $closeDate,
        pinned_at: $pinnedAt,
        pinned_at_aside: $pinnedAtAside,
        videos: $videos,
        images: $images,
        tags: $tags,
        mentions: $mentions
      }) {
        community_post ${postAttributes}
      }
    }`,
  };

  return api().get(query);
};

const updatePost = (data) => {
  const openDate = data.open_date || '';
  const closeDate = data.close_date || '';
  const pinnedAt = data.pinned_at || '';
  const pinnedAtAside = data.pinned_at_aside || '';

  const { tags, videos, title, content, kind, id, images } = data;

  const query = {
    variables: {
      title,
      content,
      kind,
      openDate,
      closeDate,
      pinnedAt,
      pinnedAtAside,
      tags,
      videos,
      images,
    },
    query: `mutation updateUserCommunityPost(
      $title: String!,
      $content: String!,
      $kind: String!,
      $openDate: String!,
      $closeDate: String!,
      $pinnedAt: String!,
      $pinnedAtAside: String!,
      $tags: [Int],
      $videos: [String],
      $images: [String]
    ) {
      updateUserCommunityPost(input: {
        id: ${id},
        title: $title,
        content: $content,
        kind: $kind,
        open_date: $openDate,
        close_date: $closeDate,
        pinned_at: $pinnedAt,
        pinned_at_aside: $pinnedAtAside,
        videos: $videos,
        images: $images,
        tags: $tags
      }) {
        community_post ${postAttributes}
      }
    }`,
  };

  return api().get(query);
};

const fetchPost = (postId) => {
  const query = {
    query: `query community_post {
      community_post(id: ${postId}) ${postAttributes}
    }`,
  };

  return api().get(query);
};

const updateModerationState = (data) => {
  const { moderationState } = data;
  const query = {
    variables: { moderationState },
    query: `mutation updateAdminCommunityPost ($moderationState: String!) {
      updateAdminCommunityPost(
        input: {
          id: ${data.postId},
          moderation_state: $moderationState
        }
      ) {
        community_post ${postAttributes}
        message
      }
    }`,
  };

  return api().get(query);
};

const likePost = (id) => {
  const query = {
    query: `mutation likeCommunityPost {
      likeCommunityPost(input: {
        id: ${id}
      }) {
        community_post ${postAttributes}
      }
    }`,
  };

  return api().get(query);
};

const destroy = (id) => {
  const query = {
    query: `mutation destroyCommunityPost {
      destroyCommunityPost(
        input: {
          id: ${id}
        }
      )
      {
        message
      }
    }`,
  };

  return api().get(query);
};

const follow = (id) => {
  const query = {
    query: `mutation followCommunityPost {
      followCommunityPost(
        input: {
          id: ${id}
        }
      )
      {
        community_post ${postAttributes}
        message
      }
    }`,
  };

  return api().get(query);
};


const unfollow = (id) => {
  const query = {
    query: `mutation unfollowCommunityPost {
      unfollowCommunityPost(
        input: {
          id: ${id}
        }
      )
      {
        community_post ${postAttributes}
        message
      }
    }`,
  };

  return api().get(query);
};

const fetchBookmarkedPosts = (communityData) => {
  const { communityId, search = '', tag = null } = communityData;
  const page = communityData.page || 1;

  const query = {
    variables: { communityId, page, search },
    query: `query community_bookmark_posts($communityId: String!, $page: Int!, $search: String) {
      community_bookmark_posts(
        community_id: $communityId,
        page: $page,
        tag: ${tag},
        search: $search
      ) ${postAttributes}
    }`,
  };

  return api().get(query);
};

const countBookmarkedPosts = (communityData) => {
  const { communityId, search, tag = null } = communityData;

  const query = {
    variables: { communityId, search },
    query: `query count_community_bookmark_posts($communityId: String!, $search: String) {
      count_community_bookmark_posts(
        community_id: $communityId,
        tag: ${tag},
        search: $search
      ) {}
    }`,
  };

  return api().get(query);
};

const createBookmark = (id) => {
  const query = {
    query: `mutation createBookmarkCommunityPost {
      createBookmarkCommunityPost(
        input: {
          id: ${id}
        }
      )
      {
        community_post ${postAttributes}
        message
      }
    }`,
  };

  return api().get(query);
};

const removeBookmark = (id) => {
  const query = {
    query: `mutation removeBookmarkCommunityPost {
      removeBookmarkCommunityPost(
        input: {
          id: ${id}
        }
      )
      {
        community_post ${postAttributes}
        message
      }
    }`,
  };

  return api().get(query);
};

const pin = (postId) => {
  const query = {
    query: `mutation pinCommunityPost {
      pinCommunityPost(
        input: {
          id: ${postId}
        }
      )
      {
        community_post {
          id
          pinned_at
        }
      }
    }`,
  };

  return api().get(query);
};

const pinAside = (postId) => {
  const query = {
    query: `mutation pinAsideCommunityPost {
      pinAsideCommunityPost(
        input: {
          id: ${postId}
        }
      )
      {
        community_post {
          id
          pinned_at_aside
        }
      }
    }`,
  };

  return api().get(query);
};

export default {
  fetchPosts,
  countPosts,
  fetchAsidePosts,
  countAsidePosts,
  createPost,
  updatePost,
  fetchPost,
  updateModerationState,
  likePost,
  destroy,
  follow,
  unfollow,
  fetchBookmarkedPosts,
  countBookmarkedPosts,
  createBookmark,
  removeBookmark,
  pin,
  pinAside,
};



// WEBPACK FOOTER //
// ./src/screens/Community/queries/post.js